import { z } from 'zod';

// ============ COMMON SCHEMAS ============

/**
 * Shared IdName schema - used for foreign key references in hierarchical models
 * Every entity with joins uses this pattern for related entity references
 */
export const idNameSchema = z.object({
  Id: z.string().optional(),
  Name: z.string().optional()
});

export type IdName = z.infer<typeof idNameSchema>;

export const idNameArraySchema = z.array(idNameSchema);

// ============ API RESPONSE SCHEMA FACTORY ============

/**
 * Generic API response schema factory
 * All API responses follow the { Data: T } pattern
 */
export const apiResponseSchema = <T extends z.ZodType>(dataSchema: T) =>
  z.object({
    Data: dataSchema
  });

/**
 * Generic API response interface
 * Used for type annotations across the API layer
 */
export interface ApiResponse<T> {
  Data: T;
}

// Common API response schemas
export const idNameApiResponseSchema = apiResponseSchema(idNameSchema);
export const idNameArrayApiResponseSchema = apiResponseSchema(idNameArraySchema);
